/*
 * Ship line date corrector.
 *
 * Liquid already rendered the arrival date, but Shopify's full-page cache can
 * hand a shopper markup that was generated hours — occasionally a day — ago, and
 * a delivery promise that is one day short is the worst kind of stale. This
 * recomputes the same sum in the browser and only touches the DOM when the two
 * disagree, so the common case is a no-op with no layout thrash.
 *
 * The formatting mirrors the Liquid side exactly (English month names, same
 * ordinal rules) so a correction can never change the wording, only the date.
 */
(function () {
  if (window.__vrnShipLine) return;
  window.__vrnShipLine = true;

  if (!window.customElements || window.customElements.get('ship-line')) return;

  var MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function ordinal(n) {
    var h = n % 100;
    if (h > 10 && h < 14) return 'th';
    switch (n % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function format(date, style) {
    var d = date.getDate();
    var m = date.getMonth();
    var month = MONTHS[m];
    var abbr = month.slice(0, 3);

    switch (style) {
      case 'month_day':
        return month + ' ' + d;
      case 'abbr_day':
        return abbr + ' ' + d;
      case 'weekday_month_day':
        return DAYS[date.getDay()] + ', ' + month + ' ' + d;
      case 'weekday_abbr':
        return DAYS[date.getDay()].slice(0, 3) + ', ' + abbr + ' ' + d;
      case 'day_month':
        return d + ' ' + month;
      case 'numeric_dm':
        return pad(d) + '/' + pad(m + 1);
      case 'numeric_md':
        return pad(m + 1) + '/' + pad(d);
      default:
        return month + ' ' + d + ordinal(d);
    }
  }

  function arrival(days, businessOnly) {
    var date = new Date();
    if (!businessOnly) {
      date.setDate(date.getDate() + days);
      return date;
    }
    var counted = 0;
    var guard = 0;
    while (counted < days && guard < 400) {
      date.setDate(date.getDate() + 1);
      var wd = date.getDay();
      if (wd !== 0 && wd !== 6) counted++;
      guard++;
    }
    return date;
  }

  window.customElements.define(
    'ship-line',
    class extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;

        var out = this.querySelector('[data-ship-date]');
        if (!out) return;

        var days = parseInt(this.dataset.days, 10);
        if (isNaN(days) || days < 0) return;

        /* The browser's clock is the shopper's, not the shop's. That is the
           right reference for "arrives by" anyway, and it is never more than a
           day away from the server's answer. */
        var next = format(arrival(days, this.dataset.business === 'true'), this.dataset.format);

        if (next && next !== out.textContent.trim()) out.textContent = next;
      }
    }
  );
})();
